import { Select } from "chakra-react-select";
import { useEffect, useState } from "react";
import { posInterface } from "../interfaces/defaultInterfaces";
import POSApi from "../services/POSApi";

export default function POSSelect({ idSelect, setIdSelect, idCliente }: any) {
    const [itemList, setItemList] = useState(Array<posInterface>);
    const [search, setSearch] = useState("");

    async function getTipoServicoList() {
        try {
            const response: any = await POSApi.getPOSList(1,100,'', idCliente);
            setItemList(response.data);
        } catch (error) {
            console.log("error", error);
        }
    }

    useEffect(() => {
        getTipoServicoList();
    }, [search]);

    const clientOptions =
        itemList &&
        itemList.map((item) => {
            return {
                key: item.codigo,
                value: item.codigo,
                label: item.codigo,
            };
        });

    function onChangeInput(item: any) {
        // console.log("evento do input", item)
        setSearch(item);
    }

    function onChangeClientFilter(e: any) {
        setIdSelect(e.value);
    }

    // useEffect(() => {
    //     if(idSelect !== 0 && idSelect !== null){
            
    //     }
    // },[idSelect]);

    return (
        <>
            <Select
                name="colors"
                // isMulti
                options={clientOptions}
                // value={cliente}
                placeholder="Filtrar por código POS"
                closeMenuOnSelect={true}
                size="md"
                onChange={(e: any) => {
                    onChangeClientFilter(e);
                }}
                onInputChange={(e: any) => {
                    onChangeInput(e);
                }}
            ></Select>
        </>
    );
}
